import styled from 'styled-components'

export const List = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-flow: row wrap;
  margin-top: 2.4rem;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin-top: 0;
  }
`

export const Item = styled.li`
  margin-right: 0.8rem;
  font-size: 1rem;

  &:last-child {
    margin-right: 0;
  }

  a {
    color: ${props => props.theme.colors.white};
  }

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin-right: 1.2rem;
    font-size: 1.2rem;
  }
`

export const SubFooterWrapper = styled.div`
  background: ${props => props.theme.colors.inputBG};
  padding: 1.5rem 0 2rem;
`

export const Wrapper = styled.footer`
  background: ${props => props.theme.colors.black};
  color: ${props => props.theme.colors.white};
  justify-content: space-between;

  .leftLinks {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    width: 100%;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      flex-direction: row;
      width: auto;
    }

    ${List} {
      width: 100%;
      justify-content: space-around;
    }
  }

  .rightLinks {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      margin-top: 2rem;
      padding-top: 0.5rem;
      align-items: flex-end;
    }

    ${Item} {
      flex: 0 1 33%;
      margin-right: 0;
      text-align: center;

      &:last-child {
        flex: 0 1 100%;
        margin-top: 2.4rem;
      }

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        flex: 0 1 auto;
        margin-right: 1rem;

        &:last-child {
          flex: 0 1 auto;
          margin-top: 0;
        }
      }
    }
  }
  .copyRightText {
    text-align: center;
    width: 100%;
    font-size: 1.2rem;
    color: ${props => props.theme.colors.brownGrey};
    margin-top: 2.4rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      text-align: right;
      margin-top: 1.4rem;
    }
  }

  img {
    width: 4.8rem;
    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 3.3rem;
    }
  }
`

export const Container = styled.div`
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 2rem 4.5rem 2rem;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex-direction: row;
    padding: 2rem 3rem 2rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding: 2rem 6.5rem 2rem 4.7rem;
  }
`

export const SubFooterContainer = styled(Container)`
  padding: 2rem;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 2rem 3rem 2rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding: 2rem 6.5rem 2rem 4.7rem;
  }
`
